<template>
  <section id="more-like-this">
    <h2
      class="h3"
      style="--margin-bottom: var(--spacing-md)"
    >
      More icons like {{ icon.name }}&hellip;
    </h2>

    <ais-instant-search
      ref="instantSearch"
      :search-client="searchClient"
      :index-name="index"
      :insights-client="insightsClient"
      :middlewares="middlewares"
      :search-parameters="{ clickAnalytics: true }"
    >
      <ais-configure
        :hits-per-page.camel="180"
        :distinct="true"
        :facet-filters.camel="facetFilters()"
      />

      <ais-hits>
        <div
          id="icons-listing"
          slot="default"
          slot-scope="{ items }"
          :class="`icon-listing ${resultsView}`"
        >
          <icon-link
            v-for="item in items"
            :key="item.objectID"
            :icon="item"
            :results-view="resultsView"
            :version="version"
          />
        </div>
      </ais-hits>
    </ais-instant-search>
  </section>
</template>

<script>
  import IconLink from './IconLink'
  import algoliasearch from 'algoliasearch/lite'

  import { fetchIndexName } from 'app/views/search/utils'
  import { aa, createInsightsMiddleware } from 'app/views/search/insightUtils'

  export default {
    name: 'MoreIconsLike',

    components: {
      IconLink
    },

    props: {
      icon: {
        type: Object,
        required: true
      },
      resultsView: {
        type: String
      },
      selectedStyle: {
        type: String
      },
      selectedFamily: {
        type: String
      },
      searchQuery: {
        type: String
      },
      version: {
        type: Number,
        default: null
      }
    },

    data() {
      return {
        index: fetchIndexName(this.$releases.active.version),
        middlewares: [createInsightsMiddleware()],
        insightsClient: aa,
        searchClient: algoliasearch(FONTAWESOME.ALGOLIA_APPLICATION_ID, FONTAWESOME.ALGOLIA_SEARCH_API_KEY)
      }
    },

    methods: {
      facetFilters() {
        const filters = []
        const categoryFilters = []

        this.icon.categories.forEach((category) => {
          categoryFilters.push(`categories:${category}`)
        })

        filters.push(categoryFilters)
        filters.push(['type:icon'])

        filters.push([`family:${this.selectedFamily}`])
        if (this.selectedFamily != 'brands') {
          filters.push([`style:${this.selectedStyle}`])
        }

        return filters
      }
    }
  }
</script>
